module.exports = __webpack_public_path__ + "static/img/5.1987fe7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news26/5.jpg
// module id = wRwc
// module chunks = 1